import { useContext } from 'react';
import { OccContextInstance } from '../types/context';
/**
 * Returns the current context value, as given by the nearest `OccContext` for the `OccContextInstance`.
 * If not defined, this will fallback to the `defaultOccContextValue`.
 */
export const useOccContext = () => useContext(OccContextInstance);
